import { Grid, Typography } from "antd";
import { useMemo } from "react";
import { CustomerOrderProductInfo } from "../../../../../../model/OrderManagement/CustomerOrder";
import { DeliveryListDto } from "../../../../../../model/OrderManagement/CustomerOrder/Delivery";
import { GoodsIssueItemInfo } from "../../../../../../model/Reservation/GoodsIssue/Item";
import VendorUsingGoodsIssueDetailInfo from "../../../../../../model/Reservation/GoodsIssue/consignment/Detail";
import WarehouseListUsingGoodsIssueDetailInfo from "../../../../../../model/Reservation/GoodsIssue/normal/Detail";
import { dateFormat } from "../../../../../../shared/utils/Dates/format";
import { CustomDescriptions } from "../../../../Description/index.styled";
import { getValueEnum } from "../../../../Unbookable/utils";
import { AddressForm } from "../../../Detail/Address";
import { CustomCard } from "../../../Detail/Card.styled";
import { DeliveryServiceVendors } from "../../../utils/DeliveryService";

interface ProductDeliveryInfoFormProps {
  dataSource?: CustomerOrderProductInfo;
}

const format = "YYYY.MM.DD HH:mm:ss";

/**
 * 상품 상세 - 배송정보
 * @param param0
 * @returns
 */
export const ProductDeliveryInfoForm: React.FC<
  ProductDeliveryInfoFormProps
> = ({ dataSource }) => {
  const screen = Grid.useBreakpoint();

  /**
   * 발송정보
   */
  const deliveryItem = useMemo(
    () =>
      (dataSource?.deliveryList as DeliveryListDto[])?.find(
        ({ deliveryType }) => deliveryType === "DELIVERY"
      ),
    [dataSource]
  );

  /**
   * 창고정보
   */
  const goodsIssue = useMemo(
    () =>
      (dataSource?.goodsIssueItem &&
        (((dataSource.goodsIssueItem as GoodsIssueItemInfo)?.vendor.id &&
          (dataSource.goodsIssueItem as GoodsIssueItemInfo)?.vendor) ||
          ((dataSource.goodsIssueItem as GoodsIssueItemInfo)?.warehouse?.id &&
            (dataSource.goodsIssueItem as GoodsIssueItemInfo)?.warehouse))) ||
      undefined,
    [dataSource]
  );

  /**
   * 발송자명
   */
  const senderName = useMemo(
    () =>
      (goodsIssue as VendorUsingGoodsIssueDetailInfo)?.vendorName ||
      (goodsIssue as WarehouseListUsingGoodsIssueDetailInfo)?.warehouseName,
    [goodsIssue]
  );

  /**
   * 수신지 정보
   */
  const destination = useMemo(
    () => dataSource?.goodsIssueItem?.goodsIssue,
    [dataSource]
  );

  /**
   * @notice card 정리하기
   */
  return (
    <>
      <CustomCard
        title={
          <Typography.Text
            style={{
              fontWeight: 700,
              lineHeight: "20px",
              fontSize: 15,
            }}
          >
            배송정보
          </Typography.Text>
        }
        headStyle={{ padding: "0 16px" }}
        style={{ width: "100%", borderRadius: 8, padding: 0 }}
        bodyStyle={{ padding: 16, marginTop: 1 }}
      >
        <CustomDescriptions
          colon={false}
          column={1}
          bordered={false}
          labelStyle={{ width: 100 }}
          layout={screen.xs ? "vertical" : "horizontal"}
        >
          <CustomDescriptions.Item label="운송장번호">
            {deliveryItem?.trackingNo || "-"}
          </CustomDescriptions.Item>
          <CustomDescriptions.Item label="택배사">
            {(deliveryItem?.deliveryVendor &&
              getValueEnum(
                deliveryItem.deliveryVendor,
                DeliveryServiceVendors
              )) ||
              "-"}
          </CustomDescriptions.Item>
          <CustomDescriptions.Item label="발송일시">
            {(deliveryItem?.deliveryStartedAt &&
              dateFormat(deliveryItem?.deliveryStartedAt, format)) ||
              "-"}
          </CustomDescriptions.Item>
          <CustomDescriptions.Item label="발송자명">
            {senderName || "-"}
          </CustomDescriptions.Item>
          <CustomDescriptions.Item label="발송지">-</CustomDescriptions.Item>
          <CustomDescriptions.Item label="수신자명">
            {destination?.destinationName || "-"}
          </CustomDescriptions.Item>
          <CustomDescriptions.Item label="수신지">
            <AddressForm
              street={destination?.destinationStreet}
              detail={destination?.destinationDetail}
              zibun={destination?.destinationZibun}
            />
          </CustomDescriptions.Item>
        </CustomDescriptions>
      </CustomCard>
    </>
  );
};
